import { dataAccessEnvironment } from './data-access-environment';

export class AuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.authToken}`;
  }
}
